import { useInfiniteQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type {
  ListNotificationsParams,
  ListNotificationsResponse,
} from './notifications.types'

const listNotifications = async (
  params?: ListNotificationsParams,
): Promise<ListNotificationsResponse> => {
  const response = await apiClient.get<ListNotificationsResponse>(
    '/v1/platform/notifications',
    {
      params: {
        FilterByNotificationType: params?.filterByNotificationType,
        FilterByMarkedAsRead: params?.filterByMarkedAsRead,
        PageSize: params?.pageSize ?? 5,
        PageNumber: params?.pageNumber ?? 1,
        OrderByDirection: params?.orderByDirection ?? 'DESC',
      },
    },
  )
  return response.data
}

export const useListNotificationsInfinite = (
  params?: Omit<ListNotificationsParams, 'pageNumber'>,
) => {
  return useInfiniteQuery({
    queryKey: ['notifications', 'infinite', params],
    queryFn: ({ pageParam }) =>
      listNotifications({ ...params, pageNumber: pageParam }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (!lastPage.pagination) return undefined
      const { pageNumber, pageSize, totalItems } = lastPage.pagination
      const hasMore = pageNumber * pageSize < totalItems
      return hasMore ? pageNumber + 1 : undefined
    },
  })
}
